export const getBaseURI = (node: {baseURI: string} = document) =>
    new URL(node.baseURI).pathname;
